// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8a325493","703":"a7209b75"}[chunkId] + ".chunk.js";
};